import { useEffect, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { AppBar, MenuItem, Popover } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../assets/Layout.css';

const tabs = [
    { label: "Home", route: "/", value: 0 },
    { label: "About Us", route: "/about-us", value: 1 },
    { label: "Registration", route: "/registration", isMulti: true, value: 2 },
    { label: "SV 7's", route: "/sv-sevens", value: 3 },
    { label: "Flag Rugby", route: "/youth", value: 4 },
    { label: "Gear", route: "/gear", value: 5 },
    { label: "Sponsors", route: "/sponsors", value: 6 }
];

const tabOptions: { [key: number]: { options: { label: string; value: string; }[]; route: string } } = {
    2: {
        options: [
            {
                label: "Youth & High School",
                value: "youth"
            },
            {
                label: "Men's & Women",
                value: "adult"
            }
        ],
        route: "/registration",
    }
}

function samePageLinkNavigation(
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
) {
    if (
        event.defaultPrevented ||
        event.button !== 0 || // ignore everything but left-click
        event.metaKey ||
        event.ctrlKey ||
        event.altKey ||
        event.shiftKey
    ) {
        return false;
    }
    return true;
}

export const Layout = () => {
    const [tabValue, setTabValue] = useState(0);
    const [popoverOptions, setPopoverOptions] = useState<{ label: string; value: string; }[]>([]);
    const [popoverRoute, setPopoverRoute] = useState("");
    const [popoverAnchor, setPopoverAnchor] = useState<(EventTarget & Element) | null>(null);

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const tabsCopy = [...tabs];
        const tab = tabsCopy.reverse().find((tab) =>  location.pathname.startsWith(tab.route));
        setTabValue(tab ? tab.value : 0);
    }, [location]);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        if (
            event.type !== 'click' ||
            (event.type === 'click' &&
            samePageLinkNavigation(
                event as React.MouseEvent<HTMLAnchorElement, MouseEvent>,
            ))
        ) {
            setTabValue(newValue);
        }
    };

    const handleMultiClick = (event: React.SyntheticEvent, tabValue: number) => {
        setPopoverAnchor(event.currentTarget);
        setPopoverOptions(tabOptions[tabValue].options);
        setPopoverRoute(tabOptions[tabValue].route);
    };

    const handleMenuItemClick = (pageValue: string) => {
        navigate(`${popoverRoute}/${pageValue}`);
        handleClose();
    }

    const handleClose = () => {
        setPopoverOptions([]);
        setPopoverRoute("");
        const tab = tabs.find((tab) =>  location.pathname.startsWith(tab.route));
        setTabValue(tab ? tab.value : 0);
    }

    
    return (
        <AppBar position="static">
            <div className='title-row'>
                Silicon Valley RFC
            </div>
            <Tabs 
                value={tabValue}
                className='navigation-row'
                onChange={handleChange}
                indicatorColor="secondary"
                textColor="inherit"
                variant="standard"
                aria-label="Nav Tabs"
            >
                {tabs.map((tab) => {
                    if(tab.isMulti) {
                        return <Tab
                            label={tab.label}
                            onClick={(e) => handleMultiClick(e, tab.value)}
                        />
                    }
                    else { 
                        return <Tab component={Link} label={tab.label} to={tab.route}/>
                    }
                })}
            </Tabs>
            <Popover 
                open={popoverOptions.length > 1}
                onClose={() => handleClose()}
                anchorEl={popoverAnchor}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
            >
                {
                    popoverOptions.map((opt) => <MenuItem onClick={() => handleMenuItemClick(opt.value)}>{opt.label}</MenuItem>)
                }
            </Popover>
        </AppBar>
    );
}